import { render, staticRenderFns } from "./order-confirm.vue?vue&type=template&id=70688904&scoped=true&"
import script from "./order-confirm.vue?vue&type=script&lang=js&"
export * from "./order-confirm.vue?vue&type=script&lang=js&"
import style0 from "./order-confirm.vue?vue&type=style&index=0&lang=less&"
import style1 from "./order-confirm.vue?vue&type=style&index=1&id=70688904&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70688904",
  null
  
)

export default component.exports